import { X } from 'lucide-react';

export function UserFormModal({ isOpen, onClose, onSave, user, mode, roles, canManageRoles }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 overflow-y-auto h-full w-full flex justify-center items-center z-50">
      <div className="relative p-6 bg-white w-full max-w-md mx-auto rounded-lg shadow-xl border border-gray-200">
        <button
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
          onClick={onClose}
          type="button"
        >
          <X className="h-5 w-5" />
        </button>
        <h3 className="text-lg font-semibold mb-4">
          {mode === 'create' ? 'Create New User' : mode === 'edit' ? 'Edit User' : 'User Details'}
        </h3>

        {mode === 'view' ? (
          <div className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide">Name</label>
              <p className="mt-1 text-sm text-gray-900">{user?.name || '-'}</p>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide">Email</label>
              <p className="mt-1 text-sm text-gray-900">{user?.email || '-'}</p>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide">Role</label>
              <p className="mt-1 text-sm text-gray-900 capitalize">{user?.role || '-'}</p>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide">Status</label>
              <span className={`inline-flex items-center mt-1 px-2 py-0.5 rounded-full text-xs font-medium ${
                user?.isActive
                  ? 'bg-success-50 text-success-700'
                  : 'bg-red-50 text-red-700'
              }`}>
                {user?.isActive ? 'Active' : 'Inactive'}
              </span>
            </div>
            <div className="flex justify-end pt-4 border-t border-gray-100">
              <button
                type="button"
                onClick={onClose}
                className="px-3 py-1.5 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              const data = Object.fromEntries(formData.entries());
              onSave(data);
            }}
          >
            <div className="mb-3">
              <label className="block text-xs font-medium text-gray-700 mb-1">Name</label>
              <input
                type="text"
                name="name"
                defaultValue={user?.name || ''}
                required
                className="block w-full px-3 py-2 text-sm rounded-md border border-gray-300 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors"
              />
            </div>
            <div className="mb-3">
              <label className="block text-xs font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                name="email"
                defaultValue={user?.email || ''}
                readOnly={mode === 'edit'}
                required
                className={`block w-full px-3 py-2 text-sm rounded-md border border-gray-300 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors ${mode === 'edit' ? 'bg-gray-50 text-gray-500' : ''}`}
              />
            </div>
            <div className="mb-3">
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Password {mode === 'edit' && <span className="text-gray-400 font-normal">(leave blank to keep)</span>}
              </label>
              <input
                type="password"
                name="password"
                required={mode === 'create'}
                className="block w-full px-3 py-2 text-sm rounded-md border border-gray-300 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors"
              />
            </div>
            {canManageRoles && (
              <div className="mb-3">
                <label className="block text-xs font-medium text-gray-700 mb-1">Role</label>
                <select
                  name="role"
                  defaultValue={user?.role || 'user'}
                  className="block w-full px-3 py-2 text-sm rounded-md border border-gray-300 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors"
                >
                  {roles.map((role) => (
                    <option key={role._id} value={role.name}>
                      {role.name}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {mode === 'edit' && (
              <div className="mb-3">
                <label className="block text-xs font-medium text-gray-700 mb-1">Status</label>
                <select
                  name="isActive"
                  defaultValue={user?.isActive ? 'true' : 'false'}
                  className="block w-full px-3 py-2 text-sm rounded-md border border-gray-300 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors"
                >
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </div>
            )}
            <div className="flex justify-end space-x-2 mt-5 pt-4 border-t border-gray-100">
              <button
                type="button"
                onClick={onClose}
                className="px-3 py-1.5 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-3 py-1.5 rounded-md text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 transition-colors"
              >
                {mode === 'create' ? 'Create' : 'Save Changes'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
